export const FaqList = () => import('../../components/HelpCenterPage/FaqList/index.vue' /* webpackChunkName: "components/faq-list" */).then(c => wrapFunctional(c.default || c))
export const SelfServices = () => import('../../components/HelpCenterPage/SelfServices/index.vue' /* webpackChunkName: "components/self-services" */).then(c => wrapFunctional(c.default || c))
export const SearchBar = () => import('../../components/HelpCenterPage/SearchBar/index.vue' /* webpackChunkName: "components/search-bar" */).then(c => wrapFunctional(c.default || c))
export const MarketsPriceTable = () => import('../../components/MarketsPricePage/MarketsPriceTable/index.vue' /* webpackChunkName: "components/markets-price-table" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
